import styled from 'styled-components';

export const SelectionHighlight = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px dashed ${({ isSelected }) => (isSelected ? '#F89B3C' : 'transparent')};
  pointer-events: none;
  z-index: 1;
`;